import { LeagueClassicPage } from './LeagueClassicPage.js';
import { LeagueMediaMini }   from './LeagueMediaMini.js';
/**
 * LeagueJLeague.js — vanilla JS class, matches LeagueWSL architecture
 */

import {
  J1_EAST_STANDINGS,
  J1_WEST_STANDINGS,
  J1_TOP_SCORERS,
  J1_FIXTURES,
  fetchLiveJLeagueData,
} from '../../data/jleagueData.js';

const STYLE_ID = 'fg-jleague-styles';
const ACCENT   = '#E60026';

function injectStyles() {
  let s = document.getElementById(STYLE_ID);
  if (!s) { s = document.createElement('style'); s.id = STYLE_ID; document.head.appendChild(s); }
  s.textContent = `
    .jl-wrap { font-family: var(--font-sans, system-ui, sans-serif); color: var(--text-color, #111); }
    .jl-hero { display:flex; align-items:center; gap:12px; padding:14px 0 12px; border-bottom:1px solid var(--border-color,#eee); flex-wrap:wrap; }
    .jl-logo-box { width:44px; height:44px; background:${ACCENT}; border-radius:10px; display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:20px; }
    .jl-hero-text h2 { font-size:17px; font-weight:700; margin:0; }
    .jl-hero-text p  { font-size:12px; color:var(--text-secondary,#666); margin:2px 0 0; }
    .jl-badge { margin-left:auto; background:${ACCENT}; color:#fff; font-size:11px; font-weight:600; padding:3px 11px; border-radius:20px; white-space:nowrap; }
    .jl-special { font-size:11px; color:var(--text-secondary,#888); border:1px solid var(--border-color,#eee); border-radius:6px; padding:4px 10px; margin-top:6px; width:100%; }
    .jl-tabs { display:flex; border-bottom:1px solid var(--border-color,#eee); overflow-x:auto; scrollbar-width:none; }
    .jl-tabs::-webkit-scrollbar { display:none; }
    .jl-tab { padding:10px 16px; font-size:13px; font-weight:400; cursor:pointer; color:var(--text-secondary,#666); border-bottom:2px solid transparent; white-space:nowrap; min-height:44px; display:flex; align-items:center; transition:color .15s; flex-shrink:0; }
    .jl-tab.is-active { color:var(--text-color,#111); border-bottom-color:${ACCENT}; font-weight:600; }
    .jl-panel { display:none; }
    .jl-panel.is-active { display:block; }
    .jl-layout { display:grid; grid-template-columns:190px 1fr; }
    .jl-sidebar { border-right:1px solid var(--border-color,#eee); }
    .jl-sidebar-sec { padding:12px; border-bottom:1px solid var(--border-color,#eee); }
    .jl-sec-label { font-size:10px; font-weight:600; letter-spacing:.7px; text-transform:uppercase; color:var(--text-secondary,#888); margin-bottom:9px; }
    .jl-main { padding:12px 14px; }
    .jl-group-hdr { font-size:10px; font-weight:800; letter-spacing:.8px; text-transform:uppercase; color:${ACCENT}; margin:14px 0 6px; }
    .jl-group-hdr:first-child { margin-top:0; }
    .jl-table { width:100%; border-collapse:collapse; font-size:12px; }
    .jl-table th { font-size:10px; font-weight:500; color:var(--text-secondary,#888); text-align:center; padding:4px 3px 6px; border-bottom:1px solid var(--border-color,#eee); }
    .jl-table th.left { text-align:left; }
    .jl-table td { padding:8px 3px; border-bottom:1px solid var(--border-color,#f0f0f0); text-align:center; }
    .jl-table td.left { text-align:left; }
    .jl-table tr:hover td { background:var(--hover-bg,#fafafa); }
    .jl-table tr.zone-playoff td:first-child { border-left:3px solid ${ACCENT}; padding-left:5px; }
    .jl-table tr.zone-none td:first-child { border-left:3px solid transparent; padding-left:5px; }
    .jl-team-cell { display:flex; align-items:center; gap:5px; }
    .jl-dot { width:9px; height:9px; border-radius:2px; flex-shrink:0; }
    .jl-team-name { font-weight:400; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:140px; }
    .jl-pts { font-weight:700; color:${ACCENT}; }
    .jl-gd-pos { color:#27ae60; font-weight:600; }
    .jl-gd-neg { color:#e74c3c; font-weight:600; }
    .jl-fix { display:flex; align-items:center; gap:6px; padding:7px 0; border-bottom:1px solid var(--border-color,#eee); font-size:11px; }
    .jl-fix:last-child { border-bottom:none; }
    .jl-fix-date { font-size:10px; color:var(--text-secondary,#888); min-width:32px; text-align:center; line-height:1.3; flex-shrink:0; }
    .jl-fix-teams { flex:1; min-width:0; }
    .jl-fix-team { display:flex; align-items:center; gap:4px; margin:1px 0; }
    .jl-fix-name { font-size:11px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100px; }
    .jl-fix-score { font-size:12px; font-weight:700; min-width:28px; text-align:right; flex-shrink:0; }
    .jl-fix-score.upcoming { color:var(--text-secondary,#888); font-weight:400; font-size:11px; }
    .jl-scorer { display:flex; align-items:center; gap:7px; padding:6px 0; }
    .jl-scorer-rank { font-size:11px; color:var(--text-secondary,#888); min-width:14px; }
    .jl-scorer-av { width:26px; height:26px; border-radius:50%; background:var(--hover-bg,#f0f0f0); border:1px solid var(--border-color,#eee); display:flex; align-items:center; justify-content:center; font-size:9px; font-weight:600; flex-shrink:0; }
    .jl-scorer-info { flex:1; min-width:0; }
    .jl-scorer-name { font-size:11px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .jl-scorer-club { font-size:10px; color:var(--text-secondary,#888); }
    .jl-scorer-goals { font-size:13px; font-weight:700; color:${ACCENT}; flex-shrink:0; }
    .jl-about h3 { font-size:14px; font-weight:700; margin-bottom:7px; }
    .jl-about p { font-size:13px; color:var(--text-secondary,#666); line-height:1.65; margin-bottom:10px; }
    .jl-about-meta { display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-top:12px; }
    .jl-meta-item { background:var(--hover-bg,#f8f8f8); border-radius:8px; padding:9px 11px; border:1px solid var(--border-color,#eee); }
    .jl-meta-label { font-size:10px; text-transform:uppercase; letter-spacing:.5px; color:var(--text-secondary,#888); margin-bottom:3px; }
    .jl-meta-val { font-size:13px; font-weight:700; }
    @media (max-width:768px) {
      .jl-layout { grid-template-columns:1fr; }
      .jl-main { order:1; padding:12px 8px; }
      .jl-sidebar { order:2; border-right:none; border-top:1px solid var(--border-color,#eee); }
      .jl-team-name { max-width:90px; }
      .jl-col-hide { display:none !important; }
      .jl-about-meta { grid-template-columns:1fr; }
    }
  `;
}

function gdLabel(gd) {
  if (gd > 0) return '<span class="jl-gd-pos">+' + gd + '</span>';
  if (gd < 0) return '<span class="jl-gd-neg">' + gd + '</span>';
  return '0';
}

function buildGroupTable(rows) {
  const trs = rows.map(function(t) {
    return '<tr class="' + (t.pos === 1 ? 'zone-playoff' : 'zone-none') + '">' +
      '<td>' + t.pos + '</td>' +
      '<td class="left"><div class="jl-team-cell"><div class="jl-dot" style="background:' + (t.color || '#888') + '"></div><span class="jl-team-name">' + t.team + '</span></div></td>' +
      '<td>' + t.played + '</td>' +
      '<td class="jl-col-hide">' + t.won + '</td>' +
      '<td class="jl-col-hide">' + t.drawn + '</td>' +
      '<td class="jl-col-hide">' + t.lost + '</td>' +
      '<td class="jl-col-hide">' + gdLabel(t.gd) + '</td>' +
      '<td class="jl-pts">' + t.pts + '</td>' +
    '</tr>';
  }).join('');
  return '<table class="jl-table"><thead><tr>' +
    '<th style="width:22px;">#</th><th class="left">Team</th><th>P</th>' +
    '<th class="jl-col-hide">W</th><th class="jl-col-hide">D</th><th class="jl-col-hide">L</th>' +
    '<th class="jl-col-hide">GD</th><th>Pts</th>' +
    '</tr></thead><tbody>' + trs + '</tbody></table>';
}

function buildFixturesSidebar(fixtures) {
  var recent   = fixtures.filter(function(f){ return f.status === 'FT'; }).slice(-3);
  var upcoming = fixtures.filter(function(f){ return f.status === 'NS'; }).slice(0, 3);
  return [].concat(recent, upcoming).map(function(f) {
    var scoreHtml = f.status === 'NS'
      ? '<div class="jl-fix-score upcoming">vs</div>'
      : '<div class="jl-fix-score">' + f.homeScore + '–' + f.awayScore + '</div>';
    return '<div class="jl-fix">' +
      '<div class="jl-fix-date">' + f.date + '</div>' +
      '<div class="jl-fix-teams">' +
        '<div class="jl-fix-team"><span class="jl-fix-name">' + f.home + '</span></div>' +
        '<div class="jl-fix-team"><span class="jl-fix-name">' + f.away + '</span></div>' +
      '</div>' + scoreHtml + '</div>';
  }).join('');
}

function buildScorersSidebar(scorers) {
  return scorers.slice(0, 6).map(function(s, i) {
    var initials = (s.name || '').split(' ').map(function(w){ return w[0]; }).join('').slice(0,2);
    return '<div class="jl-scorer">' +
      '<div class="jl-scorer-rank">' + (i+1) + '</div>' +
      '<div class="jl-scorer-av">' + initials + '</div>' +
      '<div class="jl-scorer-info">' +
        '<div class="jl-scorer-name">' + (s.nationality || '') + ' ' + s.name + '</div>' +
        '<div class="jl-scorer-club">' + s.team + '</div>' +
      '</div>' +
      '<div class="jl-scorer-goals">' + s.goals + '</div>' +
    '</div>';
  }).join('');
}

export class LeagueJLeague {
  constructor(containerId) {
    this.containerId = containerId;
    this.root        = null;
    this.data = {
      eastStandings: J1_EAST_STANDINGS,
      westStandings: J1_WEST_STANDINGS,
      topScorers:    J1_TOP_SCORERS,
      fixtures:      J1_FIXTURES,
    };
  }

  async init() {
    injectStyles();
    this.root = document.getElementById(this.containerId);
    if (!this.root) return;
    const live = await fetchLiveJLeagueData();
    if (live) {
      if (live.eastStandings) this.data.eastStandings = live.eastStandings;
      if (live.westStandings) this.data.westStandings = live.westStandings;
      if (live.topScorers)    this.data.topScorers    = live.topScorers;
      if (live.fixtures)      this.data.fixtures      = live.fixtures;
    }
    this.render();
  }

  render() {
    this.root.innerHTML = this._buildHTML();
    this._attachListeners();
  }

  _buildHTML() {
    var d = this.data;
    return '<div class="jl-wrap">' +
      '<div class="jl-hero">' +
        '<div class="jl-logo-box">⚽</div>' +
        '<div class="jl-hero-text"><h2>明治安田 J1 League</h2><p>100 Year Vision League · 2026 · Japan</p></div>' +
        '<div class="jl-badge">J1 🇯🇵</div>' +
        '<div class="jl-special">⚡ East &amp; West groups · No relegation · Feb–Jun 2026</div>' +
      '</div>' +
      '<div class="jl-tabs">' +
        '<div class="jl-tab is-active" data-jl-tab="standings">Table</div>' +
        '<div class="jl-tab" data-jl-tab="results">Results</div>' +
        '<div class="jl-tab" data-jl-tab="scorers">Scorers</div>' +
        '<div class="jl-tab" data-jl-tab="about">About</div>' +
      '<div class="jl-tab" data-jl-tab="clubs">Clubs</div>' +
      '<div class="jl-tab" data-jl-tab="media">Media</div>' +
      '<div class="jl-tab" data-jl-tab="classic">Classic</div>' +
      '</div>' +
      '<div class="jl-panel is-active" id="' + this.containerId + '-standings">' +
        '<div class="jl-layout">' +
          '<div class="jl-main">' +
            '<div class="jl-group-hdr">East Group</div>' + buildGroupTable(d.eastStandings) +
            '<div class="jl-group-hdr">West Group</div>' + buildGroupTable(d.westStandings) +
          '</div>' +
          '<div class="jl-sidebar">' +
            '<div class="jl-sidebar-sec"><div class="jl-sec-label">Fixtures &amp; Results</div>' + buildFixturesSidebar(d.fixtures) + '</div>' +
            '<div class="jl-sidebar-sec"><div class="jl-sec-label">Top Scorers</div>' + buildScorersSidebar(d.topScorers) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="jl-panel" id="' + this.containerId + '-results"><div style="padding:14px;">' + this._resultsHtml(d.fixtures) + '</div></div>' +
      '<div class="jl-panel" id="' + this.containerId + '-scorers"><div style="padding:14px;">' + this._scorersHtml(d.topScorers) + '</div></div>' +
      '<div class="jl-panel" id="' + this.containerId + '-clubs"><div style="padding:12px 0;"><div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:10px;">' + (d.standings||[]).map(function(t){return '<div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:10px;padding:14px 10px;text-align:center;"><div style="width:44px;height:44px;border-radius:50%;background:'+(t.color||'#888')+';display:flex;align-items:center;justify-content:center;margin:0 auto 8px;font-size:12px;font-weight:700;color:#fff;">'+(t.short||'?')+'</div><div style="font-size:11px;font-weight:600;color:var(--text-color,#111);line-height:1.3;margin-bottom:4px;">'+(t.name||'')+'</div><div style="font-size:10px;color:var(--text-secondary,#888);">#'+(t.pos||'')+' &middot; '+(t.pts||0)+' pts</div></div>';}).join('') + '</div></div></div>' +
      '<div class="jl-panel" id="' + this.containerId + '-media"><div style="padding:40px 20px;text-align:center;color:var(--text-secondary,#888);"><div style="font-size:15px;font-weight:600;">Media - Coming Soon</div></div></div>' +
      '<div class="jl-panel" id="' + this.containerId + '-classic"><div style="padding:40px 20px;text-align:center;color:var(--text-secondary,#888);"><div style="font-size:15px;font-weight:600;">Classic - Coming Soon</div></div></div>' +
      '<div class="jl-panel" id="' + this.containerId + '-about"><div style="padding:14px;" class="jl-about">' + this._aboutHtml() + '</div></div>' +
    '</div>';
  }

  _resultsHtml(fixtures) {
    return `<div style="padding:14px;max-width:900px;"><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9632; Overview</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Japan&#39;s top professional women&#39;s football league, the WE League (Women&#39;s Empowerment League), launched in 2021. Built on the legacy of Nadeshiko Japan&#39;s 2011 World Cup triumph.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9632; History</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Japanese women&#39;s football has a rich history dating to the L.League era. The WE League replaced it as a fully professional competition in 2021, with clubs backed by J.League parent organisations.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9733; Honours</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;"><strong>INAC Kobe Leonessa</strong> and <strong>Urawa Red Diamonds Ladies</strong> have been leading clubs. The competition is still establishing its modern honours list.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9733; Stars</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Japan&#39;s squad features world-class players including Hinata Miyazawa, Riko Ueki, and Mana Iwabuchi. Several Japanese players ply their trade in European leagues.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9632; TV &amp; Media</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Broadcast on <strong>DAZN Japan</strong> and NHK. The WE League has strong digital streaming figures, particularly among younger Japanese football fans.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9632; Europe</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Japan won the 2011 Women&#39;s World Cup and reached the 2015 final. The WE League aims to keep top talent in Japan while raising the competitive level domestically.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#E60012;">&#9632; Key Facts</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;"><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">11 clubs</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">Founded 2021</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">Oct&#8211;May</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">2011 WWC winners</span></div></div></div>`;
  }

  _scorersHtml(scorers) {
    return '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
      ['Goals','Assists'].map(function(lbl, li) {
        return '<div style="background:var(--hover-bg,#f8f8f8);border-radius:10px;padding:12px;border:1px solid var(--border-color,#eee);">' +
          '<div style="font-size:10px;font-weight:600;letter-spacing:.5px;text-transform:uppercase;color:var(--text-secondary,#888);margin-bottom:8px;">' + lbl + '</div>' +
          scorers.slice(0,6).map(function(s,i) {
            var val = li === 0 ? s.goals : (s.assists || 0);
            return '<div style="display:flex;align-items:center;gap:7px;padding:4px 0;">' +
              '<span style="font-size:10px;color:var(--text-secondary,#888);min-width:13px;">' + (i+1) + '</span>' +
              '<div style="flex:1;min-width:0;"><div style="font-size:11px;font-weight:600;">' + s.name + '</div><div style="font-size:10px;color:var(--text-secondary,#888);">' + s.team + '</div></div>' +
              '<span style="font-size:13px;font-weight:700;color:' + ACCENT + ';">' + val + '</span>' +
            '</div>';
          }).join('') + '</div>';
      }).join('') + '</div>';
  }

  _aboutHtml() {
    return '<h3>J1 100 Year Vision League</h3>' +
      '<p>A one-off transitional tournament (6 Feb – 7 Jun 2026) bridging J.League\'s move to an autumn-spring calendar. All 20 J1 clubs compete in East and West regional groups with a playoff final determining the overall champion and AFC Champions League Elite qualification.</p>' +
      '<p>No relegation this season. From 2026-27, J.League runs on a September–May calendar aligned with European leagues.</p>' +
      '<div class="jl-about-meta">' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Season</div><div class="jl-meta-val">2026 (Special)</div></div>' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Teams</div><div class="jl-meta-val">20 clubs</div></div>' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Groups</div><div class="jl-meta-val">East &amp; West</div></div>' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Goals/match</div><div class="jl-meta-val">2.65</div></div>' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Avg attendance</div><div class="jl-meta-val">21,874</div></div>' +
        '<div class="jl-meta-item"><div class="jl-meta-label">Relegation</div><div class="jl-meta-val">None</div></div>' +
      '</div>';
  }

  _attachListeners() {
    var self = this;
    this.root.querySelectorAll('[data-jl-tab]').forEach(function(tab) {
      tab.addEventListener('click', function() {
        self.root.querySelectorAll('[data-jl-tab]').forEach(function(t){ t.classList.remove('is-active'); });
        self.root.querySelectorAll('.jl-panel').forEach(function(p){ p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = self.root.querySelector('#' + self.containerId + '-' + tab.dataset.jlTab);
        if (panel) panel.classList.add('is-active')
        const _tt=t.dataset.tab||'';if(_tt==='classic'){const _ce=this.root&&this.root.querySelector('#jl-panel-classic');if(_ce&&!_ce._cpm){new LeagueClassicPage(_ce,'jleague').init();_ce._cpm=true;}}if(_tt==='media'){const _me=this.root&&this.root.querySelector('#jl-panel-media');if(_me&&!_me._mmm){new LeagueMediaMini(_me,'jleague').init();_me._mmm=true;}};
      });
    });
  }
}
